// Note: This doesn't do much, it just hides server side error texts if the invalid field is later filled out.
class FormFields {
  constructor() {
    this.init = this.init.bind(this);
    this.toggleFilledClass = this.toggleFilledClass.bind(this);
    this.init();
  }

  init() {
    const formLabels = document.querySelectorAll('[data-form-field]');

    if (formLabels) {
      formLabels.forEach((label) => {
        label.addEventListener('change', () => {
          this.toggleFilledClass(label);
        });
        label.addEventListener('keyup', () => {
          this.toggleFilledClass(label);
        });
      });
    }
  }

  toggleFilledClass(label) {
    const field = label.querySelector('input:not([type="checkbox"]), textarea, select');
    if (field) {
      if (field.value !== '') {
        label.classList.add('filled');
      } else {
        label.classList.remove('filled');
      }
    }
  }
}

export default new FormFields();
